import React, { forwardRef, PropsWithChildren } from 'react'
import { Textarea as TextareaStyles } from '@airbus/elements/elements'
import clsx from 'clsx'
import { createUseStyles } from '../../lib/styling'
import { CommonProps } from '../helperTypes'

type Props = PropsWithChildren<{
  /** If true, the input will indicate an error */
  invalid?: boolean
  /** The callback for when the input's state changes */
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>, value: string) => void
  /** If true, the input will indicate a success */
  valid?: boolean
}>

export type TextareaProps = Props & CommonProps

const useStyles = createUseStyles(TextareaStyles, 'textarea')

export const Textarea = (props: TextareaProps, ref: React.Ref<HTMLTextAreaElement>) => {
  const { children, className, valid, invalid, onChange, ...rest } = props
  const classes = useStyles()

  const handleChange = (evt: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange && onChange(evt, evt.target.value)
  }

  return (
    <textarea
      ref={ref}
      onChange={handleChange}
      className={clsx(className, classes.root, valid && classes._valid, invalid && classes._invalid)}
      {...rest}
    >
      {children}
    </textarea>
  )
}

export default forwardRef<HTMLTextAreaElement, TextareaProps>(Textarea)
